/**
 * The view where work waiting on a person collects. It was called Queue until
 * 23 Sep, and links to it were bookmarked and pasted into tickets under both
 * that name and the older `/approvals`, so both still resolve here.
 */
export const INBOX = '/inbox'

/**
 * Where a legacy link lands: the same item, under the current name, with the
 * query string it arrived with.
 *
 * Carrying `search` is the whole point -- the links that need this are
 * `?source=fleet-health` from the cost strip and `?dept=` from a desk, and a
 * redirect that dropped them would land someone on an unfiltered page and look
 * like it had worked. It is a pure function rather than a path built inside
 * the route element because there is no DOM test environment in this repo, so
 * this is the only part of the redirect a test can hold.
 */
export function inboxHref(id: string | undefined, search = ''): string {
  return `${INBOX}${id ? `/${id}` : ''}${search}`
}
